import { Component, Input, OnInit } from '@angular/core';
import { OrderingDirection } from '../utils/ordering-direction';

@Component({
    selector: 'skl-sort-icon',
    templateUrl: './sort-icon.component.html'
})
export class SortIconComponent {
    @Input() public sortDirection!: OrderingDirection;
}
